import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const EvidenceHub = ( props ) => {
  const { classes } = props;

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>Evidence Hub</h3>
              <p className={classes.aboutUsText}>
                We make high-quality development evidence publicly accessible through key databases, journals and repositories, which include studies produced by 3ie and beyond.
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}evidence-hub`}
              >
                Explore Evidence Hub
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <ul className={classes.aboutUsListGrid}>
                <li><a href="https://developmentevidence.3ieimpact.org/" rel="noopener noreferrer">Development Evidence Portal</a></li>
                <li><a href={`${SITE_LINK}evidence-hub/evidence-gap-maps`} rel="noopener noreferrer">Evidence gap maps</a></li>
                <li><a href={`${SITE_LINK}impact/evidence-impact-summaries`} rel="noopener noreferrer">Evidence impact summaries</a></li>
                <li><a href={`${SITE_LINK}impact/impact-stories-dashboard`} rel="noopener noreferrer">Impact Stories Dashboard</a></li>
                <li><a href={`${SITE_LINK}resources/journal-of-development-effectiveness`} rel="noopener noreferrer">Journal of Development Effectiveness</a></li>
                <li><a href={`${SITE_LINK}evidence-hub/publications`} rel="noopener noreferrer">Publications</a></li>
              </ul>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

EvidenceHub.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles( styles )( EvidenceHub );
